document.addEventListener('DOMContentLoaded', () => {
   setInterval(() => {
      const animatedElements = document.querySelectorAll('.wcl-word-animated');
      
      animatedElements.forEach(element => {
         element.classList.add('wcl-hide-highlight');
         setTimeout(() => {
            element.classList.remove('wcl-hide-highlight');
         }, 2000); // deletion in 2 seconds
      });
   }, 5000);
});